import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

// --- Data ---
const lossRatios = [
    { year: 2018, values: ["10.0%", "0%", "0%", "0%", "0%"] },
    { year: 2019, values: ["0%", "0%", "0%", "0%", "4.0%"] },
    { year: 2020, values: ["0%", "0%", "0%", "0%", "0%"] },
    { year: 2021, values: ["0%", "0%", "0%", "0%", "0%"] },
    { year: 2022, values: ["0%", "0%", "0%", "0%", "0%"] },
    { year: 2023, values: ["0%", "0%", "0%", "0%", "0%"] },
    { year: 2024, values: ["0%", "0%", "0%", "0%", "0%"] },
];
const headingStyle = {
  color: "#1976D2",
  textAlign: "left",
  fontWeight: 600,
  marginBottom: "8px",

};


const portfolioVarOptions = {
  chart: {
    zoomType: "xy"
  },
  title: { text: "Distribution of Portfolio VaR" ,style: { color: "#1976D2" },align: "left"},
  xAxis: {
    categories: ["10%", "20%", "30%", "40%", "50%", "60%", "70%", "80%", "90%", "100%"],
    title: { text: "VaR Range" }
  },
  yAxis: [{
    title: {
      text: "Frequency"
    }
  }],
  tooltip: {
    shared: true
  },
  legend: {
    align: "left",
    verticalAlign: "top",
    layout: "horizontal"
  },
  series: [
    {
      type: "column",
      name: "Frequency",
      data: [50, 120, 180, 250, 300, 330, 310, 200, 80, 20],
      color: "#1976D2",
    },
    {
      type: "spline",
      name: "Normal Curve",
      data: [30, 100, 160, 220, 290, 310, 290, 180, 80, 10],
      color: "#E53935",
      marker: {
        enabled: false
      }
    }
  ]
};

const diversificationOptions = {
  chart: {
    type: "line"
  },
  title: {
    text: "VAR reduction due to Diversification",
    style: { color: "#1976D2" },
    align: "left",
  },
  xAxis: {
    categories: ["High", "Medium", "Low"],
    title: { text: null }
  },
  yAxis: {
    title: {
      text: "VAR"
    }
  },
  tooltip: {
    shared: true
  },
  legend: {
    align: "center",
    verticalAlign: "bottom",
    layout: "horizontal"
  },
  series: [
    {
      name: "Selected Weights (glow)",
      data: [300, 150, 100],
      color: "#1976D2",
      lineWidth: 10,
      enableMouseTracking: false,
      linkedTo: null,
      opacity: 0.1,
      showInLegend: false
    },
    {
      name: "Selected Weights",
      data: [300, 150, 100],
      color: "#1976D2",
      lineWidth: 3,
      marker: { radius: 5 }
    },
    {
      name: "Equal Weighted (glow)",
      data: [400, 300, 200],
      color: "#AB47BC",
      lineWidth: 10,
      enableMouseTracking: false,
      linkedTo: null,
      opacity: 0.1,
      showInLegend: false
    },
    {
      name: "Equal Weighted",
      data: [400, 300, 200],
      color: "#AB47BC",
      lineWidth: 3,
      marker: { radius: 5 }
    }
  ]
};


const singleCropOptions = {
    chart: {
        type: "bar"
    },
    title: {
        text: "Single Crop - VAR",
        style: { color: "#1976D2" },
        align: "left",
    },
    xAxis: {
        categories: ["Maize", "Rice", "Wheat"],
        title: { text: null }
    },
    yAxis: {
        min: 0,
        title: { text: "VAR", align: "high" }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: "normal"
        }
    },
    series: [
        {
            name: "Low",
            data: [250, 180, 160],
            color: "#26A69A"
        },
        {
            name: "Medium",
            data: [70, 220, 100],
            color: "#FBC02D"
        },
        {
            name: "High",
            data: [100, 50, 20],
            color: "#D32F2F"
        }
    ],
    credits: {
        enabled: false
    }
};

// --- Component ---
const PortfolioRiskPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            {/* Loss Ratio Table */}
            <Paper sx={{ mb: 4, p: 2 }}>
                <Typography variant="h6" gutterBottom sx={headingStyle}>
                    Historical Loss Ratios
                </Typography>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Year</TableCell>
                                <TableCell>Maize-Gulabbagh</TableCell>
                                <TableCell>Maize-Nizamabad</TableCell>
                                <TableCell>Soyabean_Indore</TableCell>
                                <TableCell>Chana-Latur</TableCell>
                                <TableCell>Red-Chilli_Guntur</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {lossRatios.map((row) => (
                                <TableRow key={row.year}>
                                    <TableCell>{row.year}</TableCell>
                                    {row.values.map((val, i) => (
                                        <TableCell key={i}>{val}</TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            {/* Charts Row */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4, mb: 4 }}>
                <Paper sx={{ flex: 1, minWidth: "300px", p: 2 }}>
                    <HighchartsReact highcharts={Highcharts} options={portfolioVarOptions} />
                </Paper>
                <Paper sx={{ flex: 1, minWidth: "300px", p: 2 }}>
                    <HighchartsReact highcharts={Highcharts} options={diversificationOptions} />
                </Paper>
            </Box>

            {/* Single Crop VAR */}
            <Paper sx={{ p: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                    Forward Outlook:&nbsp;
                    <span style={{ color: "red" }}>High</span>,{" "}
                    <span style={{ color: "#FBC02D" }}>Medium</span>,{" "}
                    <span style={{ color: "#26A69A" }}>Low</span>
                </Typography>
                <HighchartsReact highcharts={Highcharts} options={singleCropOptions} />
            </Paper>
        </Box>
    );
};

export default PortfolioRiskPage;
